import { type SQL, sql } from "@-/com.npmjs.drizzle-orm";
import type { AnySQLiteColumn } from "@-/com.npmjs.drizzle-orm/sqlite-core";
import { staticSchema } from "@-/dev.improve.haniverse.database.schemas.static.schema";
import type { MorphemeCorpusFilter } from "#morpheme-corpus-filter";

/**
 * SQL predicate keeping only `word` rows inside the user's word corpus, for queries that `LIMIT`
 * in SQL (filtering those in JS would silently shrink the page). Simplified reads the indexed,
 * pre-aggregated `word.min_rank` (SUBTLEX-CH-WF); traditional probes `word_biau`. `undefined` when
 * there is no cutoff, so it can be passed straight into drizzle's `and(...)`.
 */
export function wordCorpusSqlCondition(
  filter: Pick<MorphemeCorpusFilter, "hanziScript" | "wordMaxRank">,
  wordIdColumn: AnySQLiteColumn = staticSchema.word.id,
): SQL | undefined {
  const { hanziScript, wordMaxRank } = filter;
  if (wordMaxRank === null) {
    return undefined;
  }
  if (hanziScript === "simplified") {
    return sql`exists (select 1 from ${staticSchema.word} as corpus_word where corpus_word.id = ${wordIdColumn} and corpus_word.min_rank <= ${wordMaxRank})`;
  }
  return sql`exists (select 1 from ${staticSchema.wordBiau} as corpus_word_biau where corpus_word_biau.word_id = ${wordIdColumn} and corpus_word_biau.rank <= ${wordMaxRank})`;
}
